export class Entransito {
  constructor(public idempresa: string, public numeroperacion: string,
              public cantidad: number,
              public tipolicencias?: string) {}
}
